<template>
<div class="outer-wrapper">
  <div class="button-wrapper">
    <Button
        class="print-button"
        slot="extra"
        v-print="printParams"
        key="to_single_print"
      >打印此页</Button>
  </div>
  <div class="content" id="to_single_print">
    <div class="inner">
      <p class="table-no">表号：SE0304-05</p>
      <p class="comnamech">上海赛恩工贸有限公司</p>
      <p class="comnameen">Shanghai Saien Industrial & Trading Co., Ltd.</p>
      <p class="title">材料验收单</p>
      <p class="sn">入库编号：<span>{{value.matnum}}</span></p>
      <table class="p1">
        <tr>
          <td width="12%"><p>品种</p></td>
          <td width="15%"><p>{{value.name}}</p></td>
          <td width="12%"><p >制造标准</p></td>
          <td width="34%" @click="alterInputClick('standard','制造标准')"><p class="cell-p" >{{value.standard}}</p></td>
          <td width="12%"><p>规格</p></td>
          <td width="15%"><p>{{'Φ'+value.diameter+'×'+value.thickness}}</p></td>
        </tr>
        <tr>
          <td><p>材料牌号</p></td>
          <td><p>{{value.grade}}</p></td>
          <td><p>供货单位</p></td>
          <td><p>{{value.seller}}</p></td>
          <td><p>数量</p></td>
          <td><p>{{value.matamount}}支</p></td>
        </tr>
        <tr>
          <td><p>炉批号</p></td>
          <td><p>{{value.stovebatch}}</p></td>
          <td><p>生产单位</p></td>
          <td><p>{{value.producer}}</p></td>
          <td><p>供货状态</p></td>
          <td @click="alterInputClick('status','供货状态')"><p>{{value.status}}</p></td>
        </tr>
      </table>
      <table class="p2">
        <tr>
          <td rowspan="4" width="5%"><p class="table-title">检验记录</p></td>
          <td colspan="2"><p>外径偏差（±1.0%D）</p></td>
          <td colspan="2"><p>壁厚偏差（±10%S）</p></td>
          <td rowspan="2" width="15%"><p>弯曲度（≤1.5mm/m）</p></td>
        </tr>
        <tr>
          <td><p>外径最大值(mm)</p></td>
          <td><p>外径最小值(mm)</p></td>
          <td><p>壁厚最大值(mm)</p></td>
          <td><p>壁厚最小值(mm)</p></td>
        </tr>
        <tr style="height:24pt;">
          <td @click="alterInputClick('diameterUp','外径最大值(mm)')"><p>{{value.diameterUp}}</p></td>
          <td @click="alterInputClick('diameterDown','外径最小值(mm)')"><p>{{value.diameterDown}}</p></td>
          <td @click="alterInputClick('thicknessUp','壁厚最大值(mm)')"><p>{{value.thicknessUp}}</p></td>
          <td @click="alterInputClick('thicknessDown','壁厚最小值(mm)')"><p>{{value.thicknessDown}}</p></td>
          <td @click="alterInputClick('bendAngle','弯曲度')"><p>{{value.bendAngle}}</p></td>
        </tr>
        <tr>
          <td colspan="5" class="free-text">
            <p>
              
              质量证明文件的项目、数据、实物标识、外观质量等符合要求；</p> 
            <p>检验结论：<span class="pass-span">合格</span></p>
            <p class="sign">
              <span class="sign-span" @click="alterSelectClick('matinssign','检验员签名')">检验员：<span class="sign-img"><img :src="urlTrans(value.matinssign)" alt="" style="width:80pt;height:30pt;"></span></span>
              <span  class="date-span">日期：<span class="date-item">{{value.takedate}}</span></span>
            </p>
          </td>
        </tr>
      </table>
      <table class="p3">
        <tr>
          <td width="5%" ><p class="table-title">审批意见</p></td>
          <td class="free-text">
            <p>材料质量证明文件：<span class="underline" @click="alterInputClick('certificate','材料质量文件')">{{value.certificate}}</span>；</p>
            <p>
              复验报告编号（如有需要时）：<span class="underline">-</span>；
            </p>
            <p>结论：<span class="pass-span">合格</span></p>
            <p>不合格处理意见：</p>
            <p class="sign"><span class="sign-span" @click="alterSelectClick('matsign','材料责任人签名')">材料责任人：<span class="sign-img"><img :src="urlTrans(value.matsign)" alt="" style="width:80pt;height:30pt;"></span></span><span class="date-span">日期：<span class="date-item">{{value.takedate}}</span></span></p>
          </td>
        </tr>
      </table>
      <p >
        <span>流程：材料检验员 → 材料责任人 </span>
        <span style="float:right;">注：□内合格√，不合格×</span>
      </p>
      <p class="sub-title">材料合格通知单（发仓库）</p>
      <div class="w1 free-text">
        <p>
          牌（钢）号<span class="underline">{{value.grade}}</span>规格<span
            class="underline"
          >{{'Φ'+value.diameter+'×'+value.thickness}}</span
          >炉批号<span class="underline">{{value.stovebatch}}</span>的材料，经验收合格准予投入使用，
          给定材料编号<span class="underline">{{value.matnum}}</span>请按有关规定标识、保管。
        </p>
        <p class="sign"><span class="sign-span" @click="alterSelectClick('matsign','材料责任人签名')">材料责任人：
          <span class="sign-img"><img :src="urlTrans(value.matsign)" alt="" style="width:80pt;height:30pt;"></span></span>
        <span class="date-span">日期：<span class="date-item">{{value.takedate}}</span></span></p>
      </div>
    </div>
  </div>

   <Modal
      v-model="modalValue.alterValue"
      :width="1000"
      :mask-closable="false"
    >
      <i
        class="ivu-icon ivu-icon-ios-close"
        slot="close"
        @click="closeModal('alterValue')"
      ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>报告内容修改（{{fileId}}）</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="base">
            <tr>
              <td><span>
                {{currentText}}：
              </span></td>
              <td style="text-align:left;"><input
                  autofocus
                  :type="currentType"
                  placeholder=""
                  v-model="currentValue"
                  style="width: 600px"
                  @keyup.enter="alterSubmit"
                /></td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button
          size="large"
          @click="alterSubmit"
          >确定</Button
        >
        <Button size="large" @click="closeModal('alterValue')">取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="modalValue.alterValueSelect"
      :width="1000"
      :mask-closable="false"
    >
      <i
        class="ivu-icon ivu-icon-ios-close"
        slot="close"
        @click="closeModal('alterValueSelect')"
      ></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>报告内容修改（{{fileId}}）</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="base">
            <tr>
              <td><span>
                {{currentText}}：
              </span></td>
              <td style="text-align:left;">
                <select v-model="currentValue">
                  <option :value="item.url" v-for="(item,index) in signatureList" :key="index">{{item.name}}</option>
                </select>
                </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button
          size="large"
          @click="alterSubmit"
          >确定</Button
        >
        <Button size="large" @click="closeModal('alterValueSelect')">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");

export default {
  name: "materialCheck",
  props: {
    fileId: {
      type: String,
    },
  },
  components: {},
  created() {
      this.getContent();
      this.getStaticOptionsData();
  },
  data() {
    return {
        defaultValue:{
            name:'无缝钢管',
            diameter:"",
            thickness:"",
            standard:"",
            producer:"",
            seller:"",
            grade:"",
            matamount:"",
            stovebatch:"",
            status:"",
            certificate:"",
            takedate:"",
        },
        value:{

        },
        printParams: {
        id: "to_single_print",
        popTitle: "",
        
      },
      fid:0,
        modalValue: {
        alterValue: false,
        alterValueSelect:false,
      },
      currentValue:"",
      currentKey:"",
      currentText:"",
      currentType:"text",
      signatureList:[],
    };
  },
  methods: {
    getStaticOptionsData(){
      this.$axios
        .post(this.$url + "/ask_static_options", {
          userToken: userToken,
          ask_data: 'signatureList',
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.signatureList = response.data.res_record.signatureList;
          }else{
            this.$Message.warning('请求选项数据失败！');
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
      getContent() {
      this.$axios
        .post(this.$url + "/content", {
          userToken: userToken,
          askData: "material",
          enid: this.fileId
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.fid = response.data.fid;
            this.adjustValue(response.data.content);
          } else {
            this.$Message.warning("未查到相关信息！");
          }
        });
    },
    adjustValue(remoteValue){
      this.value = JSON.parse(JSON.stringify(this.defaultValue));
      for(let i in remoteValue){
                  this.value[i] = remoteValue[i];
          }

    },
    alterInputClick(key,text,t="text"){
      this.currentKey = key;
      this.currentText = text;
      this.currentValue = this.value[key];
      this.currentType = t;
      this.openModal('alterValue');
    },
    alterSelectClick(key,text){
      this.currentKey = key;
      this.currentText = text;
      this.currentValue = this.value[key];
      this.openModal('alterValueSelect');
    },
    alterSubmit(){
      this.$axios
        .post(this.$url + "/content", {
          userToken: userToken,
          askData: "alterSingle",
          fid:this.fid,
          currentValue:this.currentValue,
          currentKey:this.currentKey
        })
        .then((response) => {
          if (response.data.stat == "ok") {
              this.closeModal('alterValue');
              this.closeModal('alterValueSelect');
              this.getContent();
          } else {
            this.$Message.warning("数据更新失败！");
          }
        });
    },
    openModal(label){
      this.modalValue[label] = true;
    },
    closeModal(label){
      this.modalValue[label] = false;
    },
    urlTrans(url){
      return this.$fileUrlFac(url,authData.sfileRight);
    }
  },
  computed: {
    ran:function(){
      let t1 = Math.random()/3;
      let d1 = Math.random()/2;
      let t2 = Math.random()/3;
      let d2 = Math.random()/2;
      return {thicknessUp:Math.round(10*t1)/10,diameterUp:Math.round(10*d1)/10,thicknessDown:Math.round(10*t2)/10,diameterDown:Math.round(10*d2)/10};
    },
  },
};
</script>
<style scoped>
.outer-wrapper{
  margin:0 auto;
  width:fit-content;
  text-align: center;
  padding: 10px 0 50px;
}

.button-wrapper{
  padding: 20px;
}
.content {
  height: 840.36pt;
  width: 594.3pt;
  color: #000;

  text-align: center;
  position: relative;
  margin: 1px;
}

@media screen {
  .divide-line {
    border-top: 1px solid #aaa;
  }
  .content {
    outline: #aaa solid 1px;
    box-shadow: 1px 2px 1px #aaa;
  }
}

.inner {
  padding: 50pt;
}

.content .table-title{
    font-size: 14pt;
    
}

.content p {
  font-family: "Times New Roman", "宋体";
  font-size: 10pt;
  line-height: 24pt;
}

.content .table-no {
  position: absolute;
  top: 35pt;
  right: 50pt;
  font-size: 7pt;
  color: #999;
}

.content .comnamech {
  text-align: center;
  font-size: 16pt;
  font-weight: 600;
  letter-spacing: 8pt;
  margin-top: 8pt;
}

.content .comnameen {
  text-align: center;
  font-size: 12pt;
  font-weight: 600;
}

.content .title {
  text-align: center;
  font-size: 22pt;
  margin-top: 6pt;
  font-weight: 600;
  letter-spacing: 8pt;
}

.content .sn {
  text-align: right;
  font-size: 10pt;
  margin-top: 18pt;
}

table {
  border-collapse: collapse;
  width: 100%;
}
table td {
  border: 1px solid #333;
  text-align: center;
  padding: 3pt 5pt;
}

.cell-p{
  line-height: 14pt !important;
}

.free-text{
    text-align: left;
    padding: 3pt 10pt;
}

.underline{
    display: inline-block;
    width:80pt;
    border-bottom: 1px solid #333;
    line-height: 14pt;
    text-align: center;
}

.w1{
    border:1px solid #333;
    padding: 10pt;
}

.sub-title{
    margin-top:30pt;
    text-align: center;
    font-size: 16pt !important;
    font-weight: 600;
    margin-bottom: 10pt;
}

.sign{
    margin-top:10pt;
    text-align: right;
}

.p2,.p3{
    margin-top:5pt;
}

.p1,.p2,.p3,.w1{
    border:2px solid #333;
}

.s-line{
  position: relative;
  bottom:0.5pt;
}

.p1 p{
  line-height: 1.2;
}

.sign-span{
  margin-right:100pt;
  position: relative;
}

.sign-img{
  position: absolute;
  left:60pt;
  top:-12pt;
  z-index: -1;
}

.sign-item{
  position: absolute;
  left:50pt;
  white-space: nowrap;
}

.date-span{
  margin-right:60pt;
  position: relative;
}

.date-item{
  position: absolute;
  left:30pt;
  white-space: nowrap;
}

.inner-content-wrapper{
  margin:0 auto;
  width:fit-content;
}

table.base td{
  border: none;
}

input{
  border:none;
  outline: none;
  border-bottom: 1px solid #666;
  text-align: center;
  padding: 3pt 5pt;
}
.pass-span{
  font-weight: 600;
  font-size: 14px;
}

</style>